<h1 mat-dialog-title>{{head}}</h1>
<div mat-dialog-content>
  {{msg}}
</div>

<div mat-dialog-actions>
  <button mat-button mat-dialog-close cdkFocusInitial >Ok</button>
</div>
